import { getContext } from '@/assets/js/mapContext';

export default {
  methods: {
    restorePreviousMapState() {
      getContext(this).$emit('restoreMapState', restoredMap => {
        if (!restoredMap) return;
        this.map = restoredMap;
      });
    },
  },
  created() {
    getContext(this).$off('restorePreviousMapState');
    getContext(this).$on('restorePreviousMapState', this.restorePreviousMapState);
  },
};
